"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconFasterService = function SvgIconFasterService(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "faster service icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Faster Service Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.393 10.393c5.857-5.857 15.354-5.857 21.21 0h.005c5.857 5.857 5.857 15.352 0 21.21a1.5 1.5 0 01-2.12-2.121 11.999 11.999 0 10-20.129-5.572 1.5 1.5 0 01-2.91.723 15.089 15.089 0 013.944-14.24zm-.831 24.851h13.686a1.5 1.5 0 011.5 1.5v.398a3.357 3.357 0 01-3.354 3.352H11.25a.75.75 0 01-.75-.75v-9.75a.75.75 0 01.75-.75h6.395a3.354 3.354 0 013.082 2.036 1.5 1.5 0 01-1.378 2.09h-3.787a.937.937 0 000 1.874zM7.5 28.122a1.5 1.5 0 00-1.5 1.5v10.872a1.5 1.5 0 103 0V29.62a1.5 1.5 0 00-1.5-1.498zm20.998-7.876h4.5a1.5 1.5 0 010 3h-6a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 013 0v7.5z"
  }));
};

var _default = SvgIconFasterService;
exports.default = _default;